import axios from 'axios'
import Config from './config.js'
import MD5 from './md5'
import Base64 from './base64'
import zzyDate from './datetime.js'
import cache from './cache'

export function mallRequest ({apiName, method, data = '', urldata = ''} = {}) {
  return new Promise((resolve, reject) => {
    if (!Config[apiName]) {
      reject('接口地址有误~')
    }

    // if (Config[apiName].needToken) {
    //   data.access_token = selfUser.getUserInfo('access_token');
    // }
    console.log('Request Url:', Config[apiName].url)
    console.log('Request Method:', method)
    console.log('Request Data1:', JSON.stringify(data))

    // let requestData = createRequestData(data);
    if (method == 'get') {
      data = {params: data}
    }
    console.log('Request Data2:', data)
    const instance = axios.create({
      headers: {'x-api-key': selfUser.getUserInfo('access_token')}
    })
    instance[method](Config[apiName].url + urldata, data).then((res) => {
      console.log(res)
      if (res.status == 200) {
        // let res = getResponseData(ret);
        if (res && res.data) {
          console.log(res.data.code)
          if (res.data.code == 200) {
            resolve(res.data)
          } else if (res.data.code == 401) {
            window.location.href = '/#/'
          } else {
            resolve(res.data)
          }
        } else {
          alert(res.data.message)
        }
      } else {
        if (Config.HTTP_CODE[res.status]) {
          alert(`${Config.HTTP_CODE[res.status]}[${res.status}]`)
          reject(`${Config.HTTP_CODE[res.status]}[${res.status}]`)
        } else {
          alert(`unknown error[${res.status}]`)
          reject(`unknown error[${res.status}]`)
        }
      }
    }).catch((e) => {
      reject(e)
    })
  })
}
export function createRequestData (rdata = '') {
  if (rdata == '') {
    rdata = {'empty': true}
  }

  let api_envelope = {
    version: Config.API_VERSION,
    body: '',
    signature: ''
  }
  let tmpData = {
    client_id: Config.APP_ID,
    timestamp: zzyDate.unixtimestamp(),
    content: rdata
  }
  api_envelope.body = Base64.encode(JSON.stringify(tmpData))

  api_envelope.signature = MD5(api_envelope.body + Config.APP_SECRET)
  return JSON.stringify(api_envelope)
}

// 获取输出数据
export function getResponseData (ret) {
  if (ret.data == '') {
    return {success: false, message: '服务器内部错误'}
  } else {
    return JSON.parse(Base64.decode(ret.data.body))
  }
}

export function SelfTicket () {
  console.log('SelfTicket')
}

function SelfUser () {
  this.setUserInfo = (userInfo) => {
    cache.set('user_info', JSON.stringify(userInfo))
  }
  this.getUserInfo = (field = '*') => {
    let r = cache.get('user_info', '')
    if (r) {
      r = JSON.parse(r)
    }
    if (field == '*' || field == '') {
      return r
    }
    if (r[field]) {
      return r[field]
    }
    return ''
  }
}
// let selfUser = new SelfUser();

export let selfUser = new SelfUser()



// WEBPACK FOOTER //
// ./src/components/utils/ticket.js